"use client";

import {
  useCurrencyFormatter,
  useSettlementCurrencyFormatter,
} from "~/lib/use-currency";

export function SettlementCurrencyAmount({ amount }: { amount: number }) {
  const formatUserCurrency = useSettlementCurrencyFormatter();
  return <>{formatUserCurrency(amount)}</>;
}

export function CurrencyAmount({ amount }: { amount: number }) {
  const formatUserCurrency = useCurrencyFormatter();
  return <>{formatUserCurrency(amount)}</>;
}
